document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.login-privacy-policy');

  sections.forEach(function (section) {
    const tabs = section.querySelectorAll('.login-privacy-policy__tab');
    const contents = section.querySelectorAll(
      '.login-privacy-policy__content-card'
    );

    if (!tabs.length || !contents.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const targetId = tab.getAttribute('data-privacy-tab');

        if (!targetId) return;

        /* =========================
           REMOVE ACTIVE FROM TABS
        ========================== */

        tabs.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

        /* =========================
           HIDE ALL CONTENT
        ========================== */

        contents.forEach(function (content) {
          content.classList.remove('is-active');
          content.hidden = true;
        });

        /* =========================
           ACTIVATE CLICKED TAB
        ========================== */

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        /* =========================
           SHOW TARGET CONTENT
        ========================== */

        const targetContent = section.querySelector(
          '[data-privacy-content="' + targetId + '"]'
        );

        if (targetContent) {
          targetContent.hidden = false;
          targetContent.classList.add('is-active');
        }
      });
    });
  });
});